<div class="container">
  <div class="row">
    <div class="col-60">
      <div class="d-flex flex-column align-items-center mt-4 mt-md-5 pt-5">
        <img src="assets/404/404.png" class="mt-lg-4" width="250" alt="404 - Page not Found!">
        <h1 class="mt-4">{{title | translate}}</h1>
      </div>
    </div>
  </div>
</div>
<div class="padding-go-up-button"></div>
